import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import PersonnelForm from './form';
import PersonnelDetails from './personnelDetails';
import BasePersonnel from './Layouts/basePersonnel';
import { modalState, toggleModal } from 'reducers/ui';
import { getPersonnelListTransformed } from './Selectors/personnelSelectors';
import { personnelNS } from './index';
import { columns } from './columns';
import { filters } from './filters';
import { getUserRoles } from 'reducers/users';
import { ManagerAndAbove, userHasRole } from 'utils/helper/roles';

const Personnel = ({ defaultRoles }) => {
  //Selectors----------------------------------------
  const personnel = useSelector(state => getPersonnelListTransformed(state));
  const userRoles = useSelector(state => getUserRoles(state));
  const onEdit = useSelector(state => modalState(state));
  const loading = useSelector(state => state.ui.loading);
  // Actions-----------------------------------------
  const dispatch = useDispatch();
  const dispatchToggleModal = useCallback(() => {
    dispatch(toggleModal(personnelNS));
  }, [dispatch]);

  return (
    <BasePersonnel
      onEdit={onEdit[personnelNS]}
      toggleModal={dispatchToggleModal}
      personnel={personnel}
      editable={userHasRole({
        userRoles: userRoles,
        requiredRoles: ManagerAndAbove,
      })}
      DetailComponent={PersonnelDetails}
      FormComponent={PersonnelForm}
      defaultRoles={defaultRoles}
      loading={loading}
      columns={columns}
      filters={filters}
    />
  );
};

Personnel.propTypes = {
  onEdit: PropTypes.bool,
  defaultRoles: PropTypes.array,
};

export default Personnel;
